// extracted by mini-css-extract-plugin
export default {"wrapper":"NBUEwOSNhhMvpBvYsTGR","tooltipWrapper":"rBXqI0iCWErkS4xZIkgG","tooltipIcon":"RjY8PU0RLdRpCaJxyyIq","zeroValue":"jBTgU4xePlEoB7yKau7J","dot":"JQsAtk5Hx1wwZUB4lbTp"};